import {Checkbox, css, FormControlLabel, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import React, {CSSProperties} from 'react';

type Props = {
  label: string;
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, newValue: boolean) => void;
  style?: CSSProperties;
};
export const LightCheckbox2: React.FC<Props> = (props) => {
  const {label, value, onChange, ...extraProps} = props;
  const theme = useTheme();
  const muiStyles = getStyles({theme});
  return (
    <FormControlLabel
      {...extraProps}
      css={muiStyles.checkboxWrapper}
      control={<Checkbox checked={value ?? false} onChange={(event) => onChange(event, event.target.checked)} />}
      label={label}
    />
  );
};
const getStyles: GetStylesFunction = (_options) => ({
  checkboxWrapper: css`
    & .MuiCheckbox-root {
      padding: 0 !important;
    }
  `,
});
